import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCloudArrowUp} from '@fortawesome/free-solid-svg-icons';
import FormInput from '../../../../../components/FormInput';
import CustomBorderButton from '../../../../../components/buttons/CustomBorderButton';

/**
 * File upload section component
 */
export const UploadSection = ({
  fileName,
  setFileName,
  pickedFile,
  editingFile,
  isUploadEnabled,
  onFilePick,
  onUpload,
  onClear
}) => {
  return (
    <div className="p-6">
      <div className="flex items-start gap-2.5 mb-4">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Upload Files</h3>
      </div>

      {!isUploadEnabled && (
        <div className="mb-3 p-3 bg-amber-50 dark:bg-amber-900/20 rounded-md border border-amber-200 dark:border-amber-800">
          <p className="text-xs text-amber-800 dark:text-amber-200">
            You have read-only access. Contact a market onwer to upload files.
          </p>
        </div>
      )}

      <div className="space-y-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-2">
            Description
          </label>
          <FormInput
            value={fileName}
            onChange={e => setFileName(e.target.value)}
            placeholder="e.g. dataset.csv"
            leftIcon="file"
            disabled={!isUploadEnabled}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-2">
            Choose file
          </label>
          <div className="flex items-center gap-3">
            <label
              className={`inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-surface dark:bg-gray-870 transition-colors ${
                isUploadEnabled
                  ? 'hover:bg-gray-50 dark:hover:bg-gray-700 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-brand-500 cursor-pointer'
                  : 'opacity-50 cursor-not-allowed'
              }`}
            >
              <FontAwesomeIcon icon={faCloudArrowUp} className="w-4 h-4 mr-2"/>
              Browse
              <input
                type="file"
                onChange={onFilePick}
                className="sr-only"
                disabled={!isUploadEnabled}
              />
            </label>
            {pickedFile && (
              <span className="text-xs text-gray-600 dark:text-gray-400 truncate flex-1">
                {pickedFile.name}
              </span>
            )}
          </div>
        </div>

        {pickedFile && (
          <div className="p-3 bg-surface dark:bg-gray-870 rounded-md border border-gray-200/70 dark:border-gray-600/70">
            <div className="flex items-center justify-between">
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">
                  {pickedFile.name}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  {Math.round(pickedFile.size / 1024)} KB
                </div>
              </div>
            </div>
          </div>
        )}

        {editingFile && (
          <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-md border border-yellow-200 dark:border-yellow-800">
            <div className="text-xs text-yellow-800 dark:text-yellow-200">
              <span className="font-medium">Editing:</span>{' '}
              {editingFile.description || editingFile.name || fileName}
            </div>
          </div>
        )}

        <div className="flex items-center gap-2 pt-2">
          <CustomBorderButton
            onClick={onUpload}
            captions={{idle: editingFile ? 'Update' : 'Upload'}}
            disabled={!isUploadEnabled}
            size="medium"
          />
          {(pickedFile || editingFile) && (
            <button
              onClick={onClear}
              disabled={!isUploadEnabled}
              className={`text-xs ${
                isUploadEnabled
                  ? 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:underline'
                  : 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
              }`}
            >
              Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

